// extracted by mini-css-extract-plugin
export default {"clozeDropZonePlaceholder":"markup_clozeDropZonePlaceholder__O4HW1"};